/**
 * Permission Audit Logger - Enterprise Compliance & Security Monitoring
 *
 * Provides comprehensive audit logging for all permission-related activities
 * to meet enterprise compliance requirements (SOC2, GDPR, HIPAA, etc.).
 *
 * This module has been split for better maintainability:
 * - types.ts - Audit event types and interfaces
 * - logger.ts - PermissionAuditLogger class implementation
 */

// Export types
export type {
  AuditLevel,
  PermissionActionType,
  AuditEvent,
  AuditQuery,
  AuditStats
} from './types';

// Export logger
export { PermissionAuditLogger } from './logger';

// Import logger for instance creation
import { PermissionAuditLogger } from './logger';

// Create and export singleton instance
export const permissionAudit = new PermissionAuditLogger(
  'INFO', // Will be set based on environment
  true // Enable SIEM integration in production
);

// Default export
export default permissionAudit;